import { useTranslation } from 'react-i18next';
import { Routes } from '../../router/constants';
import { useNavigate } from 'react-router-dom';
import { Card, Typography } from '@otp/ui';
import { Bookmark, BookmarkFilled, BookmarksOutline, UserBookmark } from '@otp/icons';
import { Stack } from '@mui/material';
import { useResourceStats } from 'src/hooks/query/resources/use-stats';

export const BookmarksCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${Routes.resources.path}?type=bookmarks`);
  };

  const { data } = useResourceStats();

  const rows = [
    {
      label: t('resources.bookmarks.personal-bookmarks'),
      count: data?.personalBookmarksCount || 0,
      icon: <BookmarkFilled />,
    },
    {
      label: t('resources.bookmarks.team-bookmarks'),
      count: data?.organizationBookmarksCount || 0,
      icon: <UserBookmark />,
    },
  ];

  return (
    <Card isLink onClick={onClick} className="bg-[#F8F9FD] border-none w-full">
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        className="flex gap-2 items-center "
      >
        <BookmarksOutline />
        {t('resources.bookmarks.title')}
      </Typography>

      <Stack direction="column" spacing={2} className="w-full h-full">
        {rows.map((row) => (
          <Card key={row.label} className="w-full border-none">
            <div className="flex gap-2">
              <div className="mt-1">{row.icon}</div>
              <div>
                <Typography variant="subtitle1" fontWeight="bold">
                  {row.label}
                </Typography>
                <Typography variant="subtitle2">
                  {row.count} {t('resources.bookmarks.count')}
                </Typography>
              </div>
            </div>
          </Card>
        ))}
      </Stack>

      <Typography variant="subtitle1" className="absolute bottom-4 right-12">
        {t('common.show-all')}
      </Typography>
    </Card>
  );
};
